package dev.lingvo.shared.screenshots.design.derive

import dev.lingvo.shared.ScreenshotDesignDto
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

/** Preview defaults to read-only; acceptance must name the exact saved design version. */
@Serializable
data class DeriveDevicesRequest(
    val baseVersion: Int,
    val sourceDevice: String,
    val targetDevices: List<String>,
    val dryRun: Boolean = true,
)

/** Structural outcomes are separate from browser font measurement, which the server cannot certify. */
@Serializable
enum class DeriveDeviceStatus { DERIVED, OVERRIDE, UNCHANGED, REFUSED }

/** Refusals are bounded codes, never raw parser errors or workspace text. */
@Serializable
data class DeriveDeviceOutcome(val device: String, val status: DeriveDeviceStatus, val code: String? = null)

/** Carries the complete candidate so a preview and an accepted document have identical geometry. */
@Serializable
data class DeriveDevicesResponse(
    val baseVersion: Int,
    val document: JsonObject,
    val devices: List<DeriveDeviceOutcome>,
    val saved: ScreenshotDesignDto? = null,
    val fitVerificationRequired: Boolean = true,
)
